// 읽음 중복 방지: 이 기기(브라우저)가 '어떤 글/접수의 어떤 버전'을 읽었는지 localStorage에 기록.
//  - 키: `${kind}:${id}` → 값: 읽었을 때의 버전(version = 대상의 updatedAt).
//  - 대상이 수정되면 updatedAt(버전)이 바뀌므로 저장값과 불일치 → 다시 읽음 가능(초기화 대응).
//  - 같은 버전을 이미 읽었으면 중복으로 보고 버튼 비활성.

export type ReadKind = 'post' | 'request';

const STORAGE_KEY = 'ymbridge.reads.v1';

type Store = Record<string, string>;

// localStorage는 사용 불가/손상될 수 있는 외부 경계 → 여기서만 최소한으로 방어.
function load(): Store {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Store) : {};
  } catch {
    return {};
  }
}

function save(store: Store): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // 저장 실패(용량/프라이빗 모드)는 무시 — 서버 카운트는 이미 반영됨.
  }
}

function keyOf(kind: ReadKind, id: number): string {
  return `${kind}:${id}`;
}

/** 이 기기가 해당 대상의 '이 버전'을 이미 읽었는가 */
export function hasRead(kind: ReadKind, id: number, version: string): boolean {
  return load()[keyOf(kind, id)] === version;
}

/** 이 기기가 해당 대상의 '이 버전'을 읽었음으로 기록 */
export function markRead(kind: ReadKind, id: number, version: string): void {
  const store = load();
  store[keyOf(kind, id)] = version;
  save(store);
}
